import PropTypes from "prop-types";

const AddWeekDropdown = ({ options, handleAddWeekOptionClick }) => (
  <ul>
    {options.map(({ value, text }) => (
      <li key={value} role="none">
        <button
          role="menuitem"
          onMouseDown={(e) => {
            e.preventDefault();
            handleAddWeekOptionClick(e, value);
          }}
          onTouchEnd={(e) => {
            e.preventDefault();
            handleAddWeekOptionClick(e, value);
          }}
        >
          {text}
        </button>
      </li>
    ))}
  </ul>
);

AddWeekDropdown.propTypes = {
  handleAddWeekOptionClick: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.any.isRequired,
    })
  ).isRequired,
};

export default AddWeekDropdown;
